import styled from 'styled-components/macro';

export default styled('div')`
  width: calc((${(props) => props.xs || 12} / 12) * 100%);
  max-width: calc((${(props) => props.xs || 12} / 12) * 100%);
  padding-left: 15px;
  padding-right: 15px;
`;
